import React from 'react';
import {
  Breadcrumb, Button, Input, Card, Table, Spin, Row, Col
} from 'antd';
import { useTranslation } from 'react-i18next';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';

import MainLayout from '@common/layouts/MainLayout';
import withAuth from '@common/hocs/withAuth';
import CenteredContent from '@common/components/ui/CenteredContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import ViewUser from './ViewUser';
import UserResetPassword from './UserResetPassword';
import useUsuarios from './useUsuarios';
import styles from './Usuarios.module.less';

function Usuarios() {

  const { t } = useTranslation();
  const {
    loading,
    sorter,
    isSorter,
    changeSort,
    columns, 
    isModalVisible,
    setIsModalVisible,
    resetPassword,
    loadingResetPassword,
    isModalVisibleResetPassword,
    setIsModalVisibleResetPassword,
    onUserResetPassword,
    modalData,
    createUser,
    setValueFilter,
    arrayFilter,
    isCreate
  } = useUsuarios();
 
  return (
    <MainLayout applyWidthLimit>
       {loading ? (
            <>
              <CenteredContent>
                <Spin tip={t('views.device_graphics.loading_data_graphs')} />
              </CenteredContent>
            </>
          ) : (
            <>
              <Row>
                <Col span={24} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%' }}>
                    <Row>
                      <Col xs={24} sm={24} md={20} lg={20} xl={20}>
                        <Row className="miga_title">{t('views.users.breadcrumb.users')}</Row>
                        <Row style={{ fontSize: '14px', color: '#8c8c8c' }}>
                          <Breadcrumb className={styles.date_wrapper}>
                            <Breadcrumb.Item className={styles.breadcrumb}>
                              <Link to="/">{t('menu_items.main.home')}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item className={styles.breadcrumb}>
                            {t('views.users.breadcrumb.users')}
                            </Breadcrumb.Item>
                          </Breadcrumb>
                        </Row>
                      </Col>
                      <Col xs={24} sm={24} md={4} lg={4} xl={4} className="text-right">
                        {
                          isCreate && 
                            <Button type="primary" style={{ float: 'right', padding: '.5rem 1rem 1.8rem', width: '100%' }} onClick={createUser}>
                              <PlusOutlined />
                              {t('forms.users.buttons.create')}
                            </Button>
                        } 
                      </Col>
                    </Row>
                    <Row style={{justifyContent:'space-around'}}>
                      <Col xs={18} sm={18} md={22} lg={22} xl={22} style={{ display: 'flex', marginTop: '1rem' }}>
                        <Input
                          size="large"
                          placeholder={t('common.find_by_user')}
                          prefix={<SearchOutlined />}
                          style={{}}
                          onChange={(e) => setValueFilter(e.target.value)}
                        />
                      </Col>
                      <Col xs={2} sm={2} md={2} lg={2} xl={2} style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                        <Button style={{ padding: '.5rem 1rem 1.8rem' }} onClick={changeSort}>
                          <span style={isSorter ? (sorter ? { borderBottom: '1px solid #ffa057' } : { borderTop: '1px solid #ffa057' }) : null}>
                            AZ
                          </span>
                        </Button>
                      </Col> 
                    </Row>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col span={24} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%' }}>
                    <Table
                      className={styles.table}
                      columns={columns}
                      dataSource={arrayFilter}
                      rowKey={(record) => record.id}
                      scroll={{ x: 1100 }} 
                    />
                  </Card>
                </Col>
              </Row>

              <ViewUser
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
                resetPassword={resetPassword}
                loadingResetPassword={loadingResetPassword}
                modalData={modalData}
              />

              <UserResetPassword
                isModalVisible={isModalVisibleResetPassword}
                setIsModalVisible={setIsModalVisibleResetPassword}
                onUserResetPassword={onUserResetPassword}
                modalData={modalData}
              />
            </>
          )
      }
    </MainLayout>
  );

}

export default withAuth(Usuarios);
